import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { Row, Col } from 'reactstrap';
import Button from '../components/Button';
import x_mark from '../images/x_mark.svg';

import './styles/Modal.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '540px',
    border: '0',
    boxShadow: '0 18px 32px 0 rgba(0, 0, 0, 0.24)',
    width: 'calc(100% - 20px)',
    padding: '0px',
    overflow: 'auto',
    maxHeight: '100%'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '100'
  }
};

const modalActionButtonStyle = {
  width: '200px',
  padding: '12px',
  borderRadius: '19.5px',
  backgroundImage: 'linear-gradient(to left, #c8f000, #fff000)',
  boxShadow: '0 12px 17px 0 rgba(0, 0, 0, 0.06)',
  fontSize: '12px',
  letterSpacing: '0.5px',
  textAlign: 'center',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const modalCloseButtonStyle = {
  padding: '12px',
  fontSize: '12px',
  letterSpacing: '0.5px',
  textAlign: 'right',
  fontWeight: 'bold',
  color: '#9c9c9c',
  cursor: 'pointer',
  border: '0'
};

const Modal = ({
  children,
  closeButtonText,
  actionButtonText,
  actionFunction,
  onRequestClose,
  showActionButton,
  closeButtonBackground,
  closeButtonWidth,
  showAnyButton,
  ...params
}) => (
  <ReactModal
    style={ customStyles }
    ariaHideApp={ false }
    onRequestClose={ onRequestClose }
    { ...params }
  >
    <div className="modal-close-x-mark" onClick={ onRequestClose }>
      <img alt="Cancel" src={ x_mark } />
    </div>
    <div className="react-modal-content">
      {children}
      {showAnyButton && (
        <div className="modal-buttons">
          <Row>
            <Col sm={ showActionButton ? 6 : 12 } xs={ 12 } style={ { padding: 0 } }>
              <Button
                style={
                  showActionButton
                    ? {
                      ...modalCloseButtonStyle,
                      backgroundColor: closeButtonBackground,
                      width: closeButtonWidth,
                      margin: '10px',
                      float: 'right'
                    }
                    : {
                      ...modalActionButtonStyle
                    }
                }
                buttonClass={ `button button-non-wide ${
                  showActionButton ? 'text-right' : ''
                }` }
                text={ closeButtonText }
                onClick={ onRequestClose }
              />
            </Col>
            {showActionButton && (
              <Col sm="6" xs="12" style={ { padding: 0 } }>
                <Button
                  style={ {
                    ...modalActionButtonStyle,
                    margin: '10px',
                    backgroundColor: 'lightgrey'
                  } }
                  text={ actionButtonText }
                  onClick={ actionFunction }
                />
              </Col>
            )}
          </Row>
        </div>
      )}
    </div>
  </ReactModal>
);

Modal.propTypes = {
  children: PropTypes.node,
  onRequestClose: PropTypes.func,
  closeButtonText: PropTypes.string,
  actionButtonText: PropTypes.string,
  actionFunction: PropTypes.func,
  showActionButton: PropTypes.bool,
  closeButtonBackground: PropTypes.string,
  closeButtonWidth: PropTypes.string,
  showCloseXMark: PropTypes.bool,
  showAnyButton: PropTypes.bool
};

Modal.defaultProps = {
  children: null,
  onRequestClose: () => {},
  closeButtonText: '',
  actionButtonText: '',
  actionFunction: () => {},
  showActionButton: true,
  closeButtonBackground: '#fff',
  closeButtonWidth: 'auto',
  showCloseXMark: true,
  showAnyButton: true
};

export default Modal;



// WEBPACK FOOTER //
// ./src/modals/Modal.js